import { render, staticRenderFns } from "./index.vue?vue&type=template&id=347d1704&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=347d1704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d1704",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-company(微信公众号-企业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('347d1704', component.options)
    } else {
      api.reload('347d1704', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=347d1704&scoped=true&", function () {
      api.rerender('347d1704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/Detail/index.vue"
export default component.exports